export default "assets/images/logo-canei-white-38a3f28b.svg";